module.exports = __webpack_public_path__ + "static/img/IMG_20241208_160102.2832cf7a.jpg";